module.exports = __webpack_public_path__ + "img/poster.0768fd9d.png";